//const circle = require('./literatum.js');

literatum.events = (function () {
    var instance = {};
    var listenersMap = {};

    instance.register = function (eventName, callback) {
        var listeners = listenersMap[eventName];
        if (!listeners) {
            listenersMap[eventName] = listeners = [];
        }
        listeners.push(callback);
    };

    instance.deregisterAll = function () {
        listenersMap = {};
    };

    instance.notify = function (eventName, data) {
        //console.log("Event '" + eventName + "' triggered.")
        var listeners = listenersMap[eventName];
        if (listeners) {
            listeners.forEach(function (listener) {
                listener(data);
            });
        }
    };

    return instance;
})();
